import { LoginFormData } from 'mk2/apps/users/components/LoginForm';
import { APIFailureAction, APIRequestAction, APISuccessAction } from 'mk2/helpers/action';
import { NormalizedResponse } from 'mk2/helpers/api';

///////////////////////////////////////////////////////////////////
// Login form

export const LOGIN_TRIGGER = 'LOGIN_TRIGGER';
export interface LoginTriggerAction {
    readonly type: typeof LOGIN_TRIGGER;
    readonly loginFd: LoginFormData;
}
export const LOGIN_REQUEST = 'LOGIN_REQUEST';
export interface LoginRequestAction extends APIRequestAction {
    readonly type: typeof LOGIN_REQUEST;
    readonly loginFd: LoginFormData;
}
export interface LoginNormalizedResponse extends NormalizedResponse {
    readonly result: { user: number; };
}
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export interface LoginSuccessAction extends APISuccessAction<LoginNormalizedResponse> {
    readonly type: typeof LOGIN_SUCCESS;
    readonly loginFd: LoginFormData;
}
export const LOGIN_FAILURE = 'LOGIN_FAILURE';
export interface LoginFailureAction extends APIFailureAction {
    readonly type: typeof LOGIN_FAILURE;
    readonly loginFd: LoginFormData;
}

export const loginTrigger =  (loginFd: LoginFormData): LoginTriggerAction => ({
    type: LOGIN_TRIGGER, loginFd,
});
export const loginAPI = {
    request: (loginFd: LoginFormData): LoginRequestAction => ({
        type: LOGIN_REQUEST, loginFd,
    }),
    success: (loginFd: LoginFormData, response: LoginNormalizedResponse): LoginSuccessAction => ({
        type: LOGIN_SUCCESS, loginFd, response,
    }),
    failure: (loginFd: LoginFormData, error: any): LoginFailureAction => ({
        type: LOGIN_FAILURE, loginFd, error,
    }),
};
